var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPapperPine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#E1F5E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19014_15376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7491 13.4326L16.3242 28.8534C16.6577 29.0159 17.0234 29.1013 17.3944 29.1032H20.0361C20.2571 29.1026 20.4691 29.1905 20.625 29.3472L22.0566 30.7781C22.833 31.5598 23.8889 31.9998 24.9906 32.0007C25.4455 32.0002 25.8973 31.9257 26.3282 31.78C27.8136 31.293 28.894 30.0052 29.1157 28.4578L31.9298 15.0908C32.0642 14.5338 32.0003 13.9475 31.7491 13.4326Z",
    fill: "#86D165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9343 12.0645L15.5998 14.8737C13.3215 15.1867 11.7282 17.2875 12.0412 19.5658C12.1648 20.4656 12.5792 21.3004 13.2213 21.9427L14.6521 23.3736C14.8085 23.5299 14.8963 23.742 14.8961 23.9632V26.6049C14.898 26.9759 14.9835 27.3417 15.146 27.6751L30.5683 12.2502C30.0615 12.0012 29.4841 11.9356 28.9343 12.0645Z",
    fill: "#86D165"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19014_15376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapperPine);
export default __webpack_public_path__ + "static/media/papperPine.82fe25ac557967860a9d521f1cf0951d.svg";
export { ForwardRef as ReactComponent };